module.exports = require('./helpers/bundle-url').getBundleURL('aOd2H') + "logo-dark.eefe0b7f.svg";